import { ApolloClient, InMemoryCache } from '@apollo/client';
import UploadHttpLink from 'apollo-upload-client/UploadHttpLink.mjs';

// Replace the URI with your GraphQL endpoint
const GRAPHQL_URI = process.env.REACT_APP_GRAPHQL_URI || 'http://localhost:8080/graphql';

const uploadLink = new UploadHttpLink({
  uri: GRAPHQL_URI,
});

const client = new ApolloClient({
  link: uploadLink,
  cache: new InMemoryCache(),
});

export default client;

